import { BaseComponentProps } from '@utils/types/baseComponents';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import styles from './styles.module.scss';
import EmptyStarIcon from '@assets/images/review-empty-star.svg';
import FilledStarIcon from '@assets/images/review-filled-star.svg';
import Image from 'next/image';

type Props = {
  rating: number;
  /**
   * Platform - float number; partial star rating left-to-right
   * User - integer number; full star rating right-to-left
   */
  type: 'platform' | 'user';
} & BaseComponentProps;

export function ReviewRating(props: Props) {
  const { rating, type, containerStyle } = props;

  const renderStars = useMemo(() => {
    if (type === 'platform') {
      return (
        <div className={styles.stars}>
          {Array.from({ length: Math.ceil(rating) }).map((_, index) => (
            <Image
              src={FilledStarIcon}
              alt="empty star"
              key={index}
              width={16}
              height={16}
            />
          ))}

          <div
            className={styles.stars__overlay}
            style={{ width: `${100 - (rating * 100) / Math.ceil(rating)}%` }}
          />
        </div>
      );
    }

    return (
      <div className={styles.stars}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Image
            src={index < rating ? FilledStarIcon : EmptyStarIcon}
            alt="empty star"
            key={index}
            width={16}
            height={16}
          />
        ))}
      </div>
    );
  }, [rating, type]);

  return (
    <div className={clsx([styles.reviewRating, containerStyle])}>
      {renderStars}
      <div className={styles.value}>({(rating || 0).toFixed(1)})</div>
    </div>
  );
}
